import type { AttributeReviewFieldDecisionInput } from "@/graphql/generated";
import { fixLabel } from "./valueView";

export interface FinishedRowChange {
  label: string;
  before: string;
  after: string;
}

type SavedValue = {
  store_value?: string;
  pool_value?: string | null;
  ignored?: boolean;
};

const shown = (pool: string | null | undefined, ignored?: boolean | null) =>
  ignored ? "ignored" : (pool ?? "—");

export const textOf = (value: unknown) =>
  typeof value === "string" ? value : undefined;

export function finishedRowChanges(
  row: {
    decisionStatus?: unknown;
    kind?: unknown;
    leaf?: unknown;
    path?: unknown;
    values?: unknown;
  },
  decision: AttributeReviewFieldDecisionInput,
): FinishedRowChange[] {
  const before = row.decisionStatus === "REJECTED" ? "ignored" : "approved";
  const after = decision.decision === "IGNORE" ? "ignored" : "approved";
  const changes: FinishedRowChange[] =
    before === after ? [] : [{ label: "Row", before, after }];
  if (after === "ignored") return changes;
  if (decision.path && decision.path !== row.path)
    changes.push({
      label: "Field",
      before: textOf(row.path) ?? "—",
      after: decision.path,
    });
  if (decision.kind && decision.kind !== row.kind)
    changes.push({
      label: "Kind",
      before: textOf(row.kind) ?? "—",
      after: decision.kind,
    });
  if (decision.leaf && decision.leaf !== row.leaf)
    changes.push({
      label: "Leaf",
      before: textOf(row.leaf) ?? "—",
      after: decision.leaf,
    });
  const values = Array.isArray(row.values) ? (row.values as SavedValue[]) : [];
  const saved = new Map(values.map((v) => [v.store_value, v]));
  for (const v of decision.values ?? []) {
    const old = saved.get(v.storeValue);
    const b = shown(old?.pool_value, old?.ignored);
    const a = shown(fixLabel(v) ?? old?.pool_value, v.ignored);
    if (a !== b) changes.push({ label: v.storeValue, before: b, after: a });
  }
  return changes;
}
